const getters = {
  sidebar: state => state.sidebar,
  menu: state => state.racl.menu,
  identity: state => state.racl.identity,
  feature: state => state.racl.feature,
  config: state => state.config,
  helperDoc: state => state.helperDoc,
  aiChat: state => state.aiChat
}
export default getters
